
    import Index from   "./_Index.vue"  
    import { Options, Vue } from "vue-class-component";   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "TurmaQuantidadeReprovacoes",
        components: { Index },  
    }) 
    export default class TurmaQuantidadeReprovacoes extends Vue {  
        @authStore.Getter
		public perfis!: any  
    }
